import { DrawerStore, DrawerStoreType } from '@/store/drawer';
import { useShallow } from 'zustand/react/shallow';

export const useDrawers = <T = any,>() => {
  const context = DrawerStore(useShallow((state) => state)) as DrawerStoreType<T>;

  if (!context) throw new Error('useDrawers context must be use inside DrawerStore');

  return context;
};
